import { BookOpenText, Menu, X } from "lucide-react";
import { useState } from "react";

const items = [
  ["graph", "Graph"],
  ["events", "Events"],
  ["narrators", "Narrators"],
  ["claims", "Claims"],
  ["research-loop", "Research loop"],
] as const;

export function TopNav() {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header className="top-nav">
      <button className="brand" onClick={() => go("graph")} aria-label="Return to graph">
        <span className="brand-mark"><BookOpenText size={18} strokeWidth={1.5} /></span>
        <span>Karbala <i>/</i> Epistemic Graph</span>
      </button>
      <nav className={open ? "nav-links is-open" : "nav-links"} aria-label="Primary navigation">
        {items.map(([id, label]) => (
          <button key={id} onClick={() => go(id)}>{label}</button>
        ))}
      </nav>
      <button className="menu-toggle" onClick={() => setOpen((value) => !value)} aria-label="Toggle navigation">
        {open ? <X size={21} /> : <Menu size={21} />}
      </button>
    </header>
  );
}
